import { Component, Output, EventEmitter, ViewChild } from '@angular/core';
import { HomeService } from '../../../module/home/home.service';
import { EncryptionService } from '../../services/encryption.service';

@Component({
  selector: 'app-captcha',
  template: `
    <div class="d-flex align-items-center">
      <canvas #captchaCanvas class="me-2"></canvas>
      <button (click)="refreshCaptcha()" class="btn btn-secondary btn-sm" type="button"><i class="fa fa-refresh"></i></button>
    </div>
  `
})
export class CaptchaComponent {
  @Output() captchaRefreshed = new EventEmitter<{ code: string, id: string, publicIP: string }>();
  @ViewChild('captchaCanvas', { static: false }) captchaCanvas!: any;

  captchaValue: string = '';
  characterCount: number = 6; // Default number of characters

  constructor(private homeService: HomeService,   protected encryptionService: EncryptionService,) {

  }

  ngAfterViewInit() {
    this.generateCaptcha();
  }

  generateCaptcha() {
    const canvas = this.captchaCanvas?.nativeElement;
    if (!canvas) return;

    const context = canvas.getContext('2d');

    this.homeService.getCaptcha().subscribe(
      (imageBlob: any) => {
        const image = new Image();
        const transform = this.convertBase64ToBlob(imageBlob.image);

        image.src = URL.createObjectURL(transform);

        image.onload = () => {
          canvas.width = image.width;
          canvas.height = image.height;

          context.drawImage(image, 0, 0);
          URL.revokeObjectURL(image.src);

          this.captchaValue = this.encryptionService.decrypt(imageBlob.code);

          this.captchaRefreshed.emit({
            code: this.captchaValue,
            id: imageBlob.id,
            publicIP: imageBlob.publicIP
          });
        };
      },
      (error) => {
        console.error('Error fetching captcha:', error);
      }
    );
  }


  async refreshCaptcha() {
    await this.generateCaptcha();
  }

  private convertBase64ToBlob(base64Data: string): Blob {
    // Extract content type and Base64 string
    const [prefix, base64String] = base64Data.split(',');

    // Extract the content type from the prefix
    const contentTypeMatch = prefix.match(/data:(.*?);base64/);
    const contentType = contentTypeMatch ? contentTypeMatch[1] : '';

    // Decode the Base64 string to binary data
    const byteCharacters = atob(base64String);

    // Convert the binary data to an array of bytes
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    // Create a Blob from the byte array
    return new Blob([byteArray], { type: contentType });
  }

}
